import React from 'react';
import { Modal, Button } from 'react-bootstrap'

function MessageBox(props) {
    var msg = props.message
    var text = msg.split('\n').map((item, key) => {
        return <span key={key}>{item}<br /></span>
    })
    const renderButtons = () => {
        let result = []
        var OkTitle = ''
        var okAction = {};
        //set ok action
        if (props.okAction !== undefined) {
            okAction = props.okAction;
        } else {
            okAction = props.onHide
        }
        // set cancel button
        if (props.cancelTitle !== undefined) {
            result.push(
                <Button key='cancelButton' variant='secondary' onClick={props.onHide}>{props.cancelTitle}</Button>
            )
        }
        //set ok button
        if (props.okTitle !== undefined) {
            OkTitle = props.okTitle
        } else {
            OkTitle = "OK";
        }
        result.push(
            <Button key='okButton' variant='save' onClick={okAction}>{OkTitle}</Button>
        )
        return result;
    }

    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    {text}
                </div>

            </Modal.Body>
            <Modal.Footer>
                {renderButtons()}
            </Modal.Footer>
        </Modal>
    )
}
export default MessageBox;